define((require) => {
    "use strict";

    require("es6-object-assign").polyfill();
});



// WEBPACK FOOTER //
// ./src/shared/util/ObjectPolyfill.js